export const REVIEW_STATUS_MAP = {
  0: "Draft",
  1: "In Review",
  2: "Completed"
}